import { Component, Input, OnInit, inject, DestroyRef, ViewChild, effect } from '@angular/core';
import { ResponseAnalyticsService } from 'src/app/shared/services/response-analytics/response-analytics.service';
import { ActionService } from 'src/app/shared/services/action/action.service';
import { HelpersService } from 'src/app/shared/services/helpers/helpers.service';
import { AppStateService } from 'src/app/shared/services/helpers/app-state.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import * as _ from 'lodash'
import { ScoreWidgetComponent } from '../../../../../../shared/components/score/score-widget/score-widget.component';
import { NgIf } from '@angular/common';
import { LtmsBarChartViewComponent } from '../../../../../../shared/components/graph/ltms-bar-chart-view/ltms-bar-chart-view.component';
import { LtmsErrorComponent } from '../../../../../../shared/components/ltms-error/ltms-error.component';
import { LtmsLoaderComponent } from '../../../../../../shared/components/ltms-loader/ltms-loader.component';
@Component({
    selector: 'app-action-tat-category-charts',
    templateUrl: './action-tat-category-charts.component.html',
    styleUrls: ['./action-tat-category-charts.component.scss'],
    imports: [ScoreWidgetComponent, NgIf, LtmsBarChartViewComponent, LtmsErrorComponent, LtmsLoaderComponent]
})
export class ActionTatCategoryChartsComponent implements OnInit {
  title: string = '';
  description: string = 'Stacked bar chart trending the count of closed cases, segmented by whether they met or missed the target turnaround time (TAT).';
  @Input() componentId: string = "ltms-category-" + this.getTimeStamp()
  @Input() filters: any = [];
  @ViewChild(ScoreWidgetComponent) scoreWidgetComponent!: ScoreWidgetComponent;
  destroyRef = inject(DestroyRef);
  chartId: string = "ltms-bar-chart-" + this.getTimeStamp()
  chartStaticId: string = 'ltms-tat-category-chart'
  widgetConfig: any = {
    "elementId": "ltms-widget-for-category-chart",
    "trendSelector": true,
    "viewSelector": {
      enable: true,
      type: 'chart'
    },
    "download": {
      enable: true,
      componentId: this.chartStaticId,
      data: {        
        "fileName": '',
        "title": '',
        "columns": [],
        "rows": []
      }
    },
    "fullscreen": {
      enable: true,
      componentId: this.componentId
    },
  };
  xAxis: any = {
    "title": {
      "padding": 0,
      "display": true,
      "text": "",
      "font": {
        "family": "Asap",
      },
      "color": "#7f7f7f"
    }
  };
  yAxis: any = {
    "title": {
      "padding": 0,
      "display": true,
      "text": "",
      "font": {
        "family": "Asap",
      },
      "color": "#7f7f7f"
    }
  };
  exportsData: any = [];
  dateFilterField = _.get(Helpers, 'datePicker.dateFilterType', 1) == 1 ? "feedback_request_date" : "created_date";
  isDataLoaded: boolean = false;
  scoreTrendDataAvailable: boolean = false;
  activeTabLabel: string = "- Average TAT (Hours)"
  chartData: any = {
    chartId: this.chartStaticId,
    xAxis: {},
    yAxis: {},
    chart: {
      title: '',
      description: '',
      trendType: 'Monthly',
      xValues: [],
      hiddenValues: [],
      yValues: [],
      gradientColors: ["#301A4B", "#301A4B0F"],
      borderColor: '#301A4B',
      pointBorderColor: 'white',
      pointBackgroundColor: '#301A4B',
      pointHoverBackgroundColor: '#301A4B'
    },
    enable_click: true
  }
  dataSource: any = {}
  universalFilter: any = {}
  selectedTrendType: any = {};
  showPercentage: boolean = false;
  errorCode: string = '404';
  isDataAvailable: boolean = false;
  brandDetails: any = {}
  hierarchStack: any = [];
  startDate: any = '';
  endDate: any = '';
  isRequestDate: any = '';
  isFullScreen: boolean = false;
  downloadReportHeader: any = [];
  accountDetails: any = {};

  scoreWidget(): any {
    return {
      isFullScreenButtonShow: true,
      isDownloadButtonShow: true,
      isTrendDropdownShow: true,
      isAbsoluteChartShow: true,
      isPercenttageChartShow: true
    };
  }

  constructor(
    public _actionService: ActionService,
    private _analytics: ResponseAnalyticsService,
    private _helpers: HelpersService,
    private _appStateService: AppStateService
  ) { 
    effect(()=>{
      if (this._appStateService.initialized()) {
        this.universalFilter = this._appStateService.universalFilter()
        this.hierarchStack = this._appStateService.hierarchyStack();
        const datePicker:any = this._appStateService.datePicker()
        this.isRequestDate = datePicker.isRequestDate
        this.getTrendsData(this.selectedTrendType);
      }
    })
    // Add event listeners for Escape key and click outside
    document.addEventListener('keydown', this.handleKeyDown.bind(this));
    document.addEventListener('click', this.handleClickOutside.bind(this));
  }

  ngOnInit(): void {
    this._helpers.appState.pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe((params: any) => {
      if (params && !params.pending) {
        this.startDate = params.datePicker.startDate;
        this.endDate = params.datePicker.endDate;
        this.universalFilter = params.universalFilter ? params.universalFilter : {};
        this.title = (params.hierarchyStack && params.hierarchyStack.length) ? 'TAT Status Distribution - Trend - ' + params.hierarchyStack[0].group_key[0] : 'TAT Status Distribution - Trend - '+ params.brandDetails.name;
        this.isRequestDate = params.datePicker.isRequestDate;
        this.brandDetails = params.brandDetails
        this.accountDetails = params.accountDetails
        this.hierarchStack = params.hierarchyStack;
        this.initCompnent();
      }
    })

  }

    ngOnChanges() {
      if (!_.isEmpty(this.filters)) {
        this.onTrendTypeChange(this.selectedTrendType, true)
      }
      this.initCompnent();
    }

  initCompnent() {
    this.widgetConfig = {
      "elementId": "ltms-widget-for-category-chart",
      "trendSelector": true,
      "viewSelector": {
        enable: true,
        type: 'chart'
      },
      "download": {
        enable: true,
        componentId: this.chartStaticId,
        data: {
          "fileName": '',
          "title": '',
          "columns": [],
          "rows": []
        }
      },
      "fullscreen": {
        enable: true,
        componentId: this.componentId
      },
    }
    // this.onTrendTypeChange(this.selectedTrendType)
  }

  onDownload() {
    let downloadConfig: any = {
      dataKey: 'uniqueId',
      headerKey: 'header',
      data: [{
        columns: this.downloadReportHeader,
        rows: this.exportsData
      }]
    }
    
    downloadConfig.fileDetails = {
      title: "Action Trend - Closed Actionables " + this.selectedTrendType.name,
      fileName: "Action Trend - Closed Actionables " + this.selectedTrendType.name,
      accountName: this.accountDetails.display_name || this.accountDetails.name,
      brandName: this.brandDetails.display_name || this.brandDetails.name
    }

    if (downloadConfig.data.length) {
      this._analytics.prepareAndDownloadData(downloadConfig);
    }
  }

  onFullScreen (event: any) {
    this.isFullScreen = event;
  }

    // Method to handle Escape key press
  handleKeyDown(event: KeyboardEvent) {
    if (event.key === 'Escape' && this.isFullScreen) {
      this.scoreWidgetComponent.onFullscreen(); // Call the onFullscreen method from ScoreWidgetComponent
    }
  }

  // Method to handle clicks outside the content
  handleClickOutside(event: MouseEvent) {
    const overlayElements = document.getElementsByClassName('fullscreen'); // Get all elements with the overlay class
    const contentElements = document.getElementsByClassName('action-category-container'); // Get all elements with the content class

    // Check if the clicked element is the overlay
    const isOverlayClick = Array.from(overlayElements).some(overlay => overlay.contains(event.target as Node));
    const isContentClick = Array.from(contentElements).some(content => content.contains(event.target as Node));

    if (this.isFullScreen && isOverlayClick && !isContentClick) { // Only exit fullscreen if the overlay is clicked
      this.scoreWidgetComponent.onFullscreen(); // Call the onFullscreen method from ScoreWidgetComponent
    }
  }

  ngOnDestroy(): void {
    // Remove event listeners and reset
    document.removeEventListener('keydown', this.handleKeyDown.bind(this));
    document.removeEventListener('click', this.handleClickOutside.bind(this));
  }

  getTimeStamp() {
    return new Date().getTime()
  }

  onTrendTypeChange(trendType: any, drillDownEnabled:any) {
    this.selectedTrendType = trendType
    this.getTrendsData(trendType);
    if (!_.isEmpty(this.filters) && !_.isEmpty(this.filters.filters) && this.filters.groupKeyAlias) {
      _.each(this.filters.filters, (filter) => {
        if (filter && filter.field_id == this.filters.groupKeyAlias) {
          this.title = 'TAT Status Distribution - Trend - ' + filter.field_value
        } else {
          this.title = (this.hierarchStack && this.hierarchStack.length) ? 'TAT Status Distribution - Trend - ' + this.hierarchStack[0].group_key[0] : 'TAT Status Distribution - Trend - '+ this.brandDetails.name;
        }
      })
    } else {
      this.title = (this.hierarchStack && this.hierarchStack.length) ? 'TAT Status Distribution - Trend - ' + this.hierarchStack[0].group_key[0] : 'TAT Status Distribution - Trend - '+ this.brandDetails.name;
    }
    this.widgetConfig['download']['data']['fileName'] = "Action Trend - TAT" + " " + trendType.name
    this.widgetConfig['download']['data']['title'] = "Action Trend - TAT" + " - " + trendType.name
  }
  onViewChange(event: any) {
    this.showPercentage = event
    if (this.showPercentage) {
      this.chartData.yAxis.title.text = "Percentage of Cases";
      this.chartData.chart.yValues = [{
        label: "Within TAT",
        borderColor: "#136B8D",
        backgroundColor: '#136B8D',
        data: this.dataSource.percent.within_tat
      }, {
        label: "Missed TAT",
        borderColor: "#F3B34D",
        backgroundColor: '#F3B34D',
        data: this.dataSource.percent.outside_tat
      }]
    } else {
      this.chartData.yAxis.title.text = "Count of Cases";
      this.chartData.chart.yValues = [{
        label: "Within TAT",
        borderColor: "#136B8D",
        backgroundColor: '#136B8D',
        data: this.dataSource.within_tat
      }, {
        label: "Missed TAT",
        borderColor: "#F3B34D",
        backgroundColor: '#F3B34D',
        data: this.dataSource.outside_tat
      }]
    }
    this.chartId = "ltms-bar-chart-" + this.getTimeStamp()
  }

  getTrendsData(trendType?: any) {
    this.isDataLoaded = false;
    let params = this._actionService.getTrendsRequestParams({
      dateFilterField: this.isRequestDate ? "feedback_request_date" : "created_date",
      trendType: trendType.trend_type,
      appliedfilters: _.get(this.filters, 'filters', [])
    })
    params.universal_filter = this.universalFilter
    params.actionable_filter = _.get(this.brandDetails, "action_management_configuration.actionables", {});
    params.age_type = _.get(this.brandDetails, "action_management_configuration.ageing_config.type", 1);
    params.turnaround = _.get(this.brandDetails, "action_management_configuration.ageing_config.turnaround_time", 0);
    params.from = this.startDate;
    params.to = this.endDate;

    params.action_type = 'tat'
    params.group_key_alias = _.get(this.filters, 'groupKeyAlias', 'brands');
    this._actionService.getTrendsData(params).pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe({
      next: (response) => {
        if (this.validateApiResponse(response)) {
          let trendData = _.get(response, 'data.response', [])
          trendData = _.map(trendData, (data: any) => {
            if (data) {
              data.total_count = data.outside_tat + data.within_tat
            }
            return data;
          })
          this.dataSource = this._actionService.processTrendsData(trendData);
          const fieldsToExport = this.getExportsFields(trendType.name)
          this.exportsData = this._actionService.prepareDataForExport(trendData, fieldsToExport)
          fieldsToExport.push({
            header: "Missed TAT %",
            dataKey: "percent.outside_tat",
            type: "number",
            order: "5",
            defaultValue: 0,
            display_format: ""
          },{
            header: "Within TAT %",
            dataKey: "percent.within_tat",
            type: "number",
            order: "6",
            defaultValue: 0,
            display_format: ""
          })
          this.widgetConfig.download.data.columns = fieldsToExport;
          this.downloadReportHeader = fieldsToExport;
          this.chartData.chart.tooltipFields = fieldsToExport
          this.chartData.chart.tooltipData = this.exportsData
          this.chartData.chart.xValues = this.dataSource.timestamp
          this.chartData.xAxis = this.xAxis;
          this.chartData.yAxis = this.yAxis;
          this.chartData.xAxis.title.text = this.isRequestDate ? "Request Date" : "Response Date";
          this.chartData.yAxis.title.text = "Count of Cases";
          this.chartData.chart.trendType = trendType.name
          this.chartData.chart.yValues = [{
            label: "Within TAT",
            borderColor: "#136B8D",
            backgroundColor: '#136B8D',
            data: this.dataSource.within_tat
          }, {
            label: "Missed TAT",
            borderColor: "#F3B34D",
            backgroundColor: '#F3B34D',
            data: this.dataSource.outside_tat
          }]

          this.widgetConfig.download.data.rows = this.exportsData;
          this.chartId = "ltms-bar-chart-" + this.getTimeStamp();
          this.isDataAvailable = true;
          this.isDataLoaded = true;
        }
        else {
          this.isDataAvailable = false;
          this.isDataLoaded = true;
        }
      },
      error: (err) => {
        this.isDataAvailable = false;
        this.isDataLoaded = true;
        if (err.status == '500') {
          this.errorCode = '500'
        } else if (err.status == "404") {
          this.errorCode = '404'
        } else if (err.status == "408") {
          this.errorCode = '408'
        }
      }
    })
  }
  validateApiResponse(response: any) {
    return (response.code == 0 && _.hasIn(response, 'data.response') && !_.isEmpty(response.data.response))
  }
  getExportsFields(trendType: string) {
    const fieldsToExport: any = [{
      header: "Date",
      dataKey: "time",
      type: "date",
      defaultValue: "",
      order: "1",
      trendType: trendType,
      addInTooltip: false,
      showPercentage: false,
      format: ""
    }, {
      header: "Total",
      dataKey: "total_count",
      addInTooltip: true,
      showPercentage: true,
      totalKey: "total_count",
      type: "number",
      order: "7",
      defaultValue: 0,
      format: ""
    }, {
      header: "Within TAT",
      dataKey: "within_tat",
      type: "number",
      order: "2",
      addInTooltip: true,
      showPercentage: true,
      totalKey: "total_count",
      defaultValue: 0,
      format: ""
    }, {
      header: "Missed TAT",
      dataKey: "outside_tat",
      addInTooltip: true,
      showPercentage: true,
      totalKey: "total_count",
      type: "number",
      order: "3",
      defaultValue: 0,
      display_format: ""
    }, {
      header: "Average TAT(Hrs)",
      addInTooltip: true,
      showPercentage: false,
      dataKey: "tat",
      order: "4",
      type: "number",
      defaultValue: 0,
      format: "round"
    }]
    return fieldsToExport
  }

  onChartClick(data: any) {
    const dateObject = data.dateRange
    dateObject.isCustomDateRangeSelected = true
    this._helpers.setDatePicker(data.dateRange)
  }
}
